import { useTranslation } from "react-i18next";
import UserAvatar from "../../common/UserAvatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBell,
	faChevronLeft,
	faChevronRight,
	faEllipsisH,
	faThumbtack,
	faTools
} from "@fortawesome/free-solid-svg-icons";
import ThreadPrefixes from "../../common/ThreadPrefixes";
import ReactPaginate from "react-paginate";
import LoadingContent from "../../common/LoadingContent";
import LoadingNoMoreContent from "../../common/LoadingNoMoreContent";
import PopupMenu from "../../common/PopupMenu";
import ThreadActionItems from "../../Thread/section/ThreadActionItems";
import React, {useContext} from "react";
import {AuthContext} from "../../../context/authContext";

const ThreadListItem = ({ thread }) => {
	const {visitor} = useContext(AuthContext);

	return (
		<div className="flex w-full items-center">
			<div className="p-2 flex-grow-0 flex-shrink-0">
				<div className="w-[24px] h-[24px] md:w-[36px] md:h-[36px]">
					<UserAvatar user={thread.User} />
				</div>
			</div>

			<div className="p-2 flex-1 relative">
				<div className="absolute top-5 right-5 text-xs text-url inline-flex items-center gap-x-2 lg:static lg:float-right">
					{thread.sticky && <FontAwesomeIcon icon={faThumbtack} className="text-green-600" />}
					{thread.is_watching && <FontAwesomeIcon icon={faBell} />}
				</div>

				<div>
					<a
						href={thread.view_url}
						title={thread.title}
						className="inline-flex flex-col items-start gap-x-2 text-url hover:text-white lg:flex-row lg:items-center"
					>
						<div className="inline-block">
							<ThreadPrefixes thread={thread} />
						</div>

						<h4 className={`${thread.discussion_state === "deleted" && "line-through opacity-60"}`}>
							{thread.title}
						</h4>
					</a>

					<div className="flex text-white text-xs items-center gap-x-2">
						<a href={thread.User ? thread.User.view_url : "#"}>{thread.username}</a>

						<>&#183;</>

						<a href={thread.view_url}>{thread.post_date}</a>

						{thread.can_edit && visitor && visitor.is_admin && (
							<div>
								<PopupMenu
									label={
										<div className="py-1 px-2 text-sm text-white bg-primary rounded-md inline-flex items-center">
											<FontAwesomeIcon icon={faEllipsisH} />
										</div>
									}>
									<div className="szh-menu-container-background">
										<ThreadActionItems thread={thread}/>
									</div>
								</PopupMenu>
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="hidden p-2 w-[135px] text-sm text-white flex-shrink-0 flex-grow-0 lg:block">
				<div className="flex items-center justify-between">
					<span>Trả lời:</span>
					<b>{thread.reply_count_short}</b>
				</div>

				<div className="flex items-center justify-between">
					<span>Xem:</span>
					<b>{thread.view_count_short}</b>
				</div>
			</div>

			<div className="hidden p-2 w-[140px] text-url flex-shrink-0 flex-grow-0 lg:block">
				<a href={thread.view_url} title={thread.title} className="block">
					{thread.last_post_date}
				</a>
				<a href={thread.view_url} title={thread.title} className="block text-sm">
					{thread.last_post_username}
				</a>
			</div>
		</div>
	);
};

const ThreadList = ({ threads, currentPage, pageCount, onPageChange, loading = false }) => {
	const { t } = useTranslation();

	return (
		<div>
			{threads && threads.length > 0 ? (
				<ul>
					{threads.map((thread, index) => (
						<li key={index} className="border-b border-borderColor">
							<ThreadListItem thread={thread} />
						</li>
					))}
				</ul>
			) : (
				<div className="p-1 text-white text-center md:p-4">
					{loading || currentPage > 1 ? (
						<LoadingContent/>
					) : (
						<LoadingNoMoreContent/>
					)}
				</div>
			)}

			{pageCount > 1 && (
				<div className="mt-4">
					<ReactPaginate
						previousLabel={
							<span>
								<FontAwesomeIcon icon={faChevronLeft} className="text-xs" /> Trang trước
							</span>
						}
						nextLabel={
							<span>
								Trang sau <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
							</span>
						}
						breakLabel={"..."}
						breakClassName={"break-me"}
						pageCount={pageCount}
						marginPagesDisplayed={2}
						pageRangeDisplayed={5}
						onPageChange={onPageChange}
						containerClassName={"pagination"}
						subContainerClassName={"pages pagination"}
						activeClassName={"active"}
						initialPage={currentPage - 1}
					/>
				</div>
			)}
		</div>
	);
};

export default ThreadList;
